import * as types from './tasks.types';

export const tasksPageSelectors: types.ITasksPageSelectors = {
  selectReducedTasks: (state) => state.page.tasks.reducedTasks,
};
